var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawAddFilesReV09GDark2023171042(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1.114em",
    height: "1em",
    viewBox: "0 0 391 351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 200.253906 0.765625 L 187.53125 4.046875 L 30.78125 44.46875 L 18.054688 47.75 C 5.199219 51.082031 -2.539062 64.191406 0.765625 77.058594 L 55.9375 290.996094 C 59.265625 303.855469 72.378906 311.59375 85.246094 308.289062 L 85.277344 308.28125 L 267.410156 261.3125 L 267.441406 261.304688 C 280.300781 257.972656 288.035156 244.863281 284.734375 231.996094 L 229.5625 18.058594 C 226.234375 5.199219 213.121094 -2.539062 200.253906 0.765625 Z M 200.253906 0.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 201.984375 7.472656 L 186.914062 11.359375 L 34.855469 50.570312 L 19.785156 54.457031 C 10.628906 56.832031 5.121094 66.167969 7.472656 75.328125 L 62.644531 289.269531 C 65.015625 298.425781 74.351562 303.933594 83.515625 301.582031 L 83.546875 301.574219 L 265.679688 254.605469 L 265.714844 254.597656 C 274.871094 252.222656 280.378906 242.886719 278.027344 233.726562 L 222.855469 19.785156 C 220.484375 10.628906 211.148438 5.121094 201.984375 7.472656 Z M 201.984375 7.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 190.605469 76.75 L 98.46875 100.511719 C 96.328125 101.0625 94.140625 99.773438 93.589844 97.632812 C 93.035156 95.488281 94.324219 93.304688 96.46875 92.75 L 188.605469 68.992188 C 190.746094 68.441406 192.929688 69.730469 193.480469 71.871094 C 194.035156 74.011719 192.746094 76.199219 190.605469 76.75 Z M 190.605469 76.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 209.988281 85.71875 L 101.847656 113.605469 C 99.703125 114.160156 97.519531 112.871094 96.964844 110.726562 C 96.414062 108.585938 97.703125 106.398438 99.84375 105.847656 L 207.988281 77.960938 C 210.128906 77.40625 212.316406 78.695312 212.867188 80.839844 C 213.421875 82.980469 212.132812 85.167969 209.988281 85.71875 Z M 209.988281 85.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 205.738281 135.4375 L 113.605469 159.199219 C 111.460938 159.75 109.277344 158.460938 108.722656 156.320312 C 108.171875 154.175781 109.460938 151.992188 111.601562 151.4375 L 203.738281 127.679688 C 205.882812 127.125 208.066406 128.414062 208.621094 130.558594 C 209.171875 132.699219 207.882812 134.886719 205.738281 135.4375 Z M 205.738281 135.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 225.121094 144.40625 L 116.980469 172.292969 C 114.835938 172.847656 112.652344 171.558594 112.101562 169.414062 C 111.546875 167.273438 112.835938 165.085938 114.980469 164.535156 L 223.121094 136.644531 C 225.265625 136.09375 227.449219 137.382812 228.003906 139.527344 C 228.554688 141.667969 227.265625 143.855469 225.121094 144.40625 Z M 225.121094 144.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 220.875 194.125 L 128.738281 217.886719 C 126.59375 218.4375 124.414062 217.148438 123.859375 215.003906 C 123.308594 212.863281 124.59375 210.679688 126.738281 210.125 L 218.875 186.363281 C 221.015625 185.8125 223.203125 187.101562 223.753906 189.246094 C 224.304688 191.386719 223.015625 193.574219 220.875 194.125 Z M 220.875 194.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 240.257812 203.09375 L 132.113281 230.980469 C 129.972656 231.535156 127.785156 230.246094 127.230469 228.101562 C 126.679688 225.957031 127.96875 223.773438 130.113281 223.21875 L 238.253906 195.332031 C 240.398438 194.78125 242.582031 196.070312 243.136719 198.210938 C 243.6875 200.355469 242.398438 202.539062 240.257812 203.09375 Z M 240.257812 203.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 82.742188 124.875 L 50.132812 133.28125 C 49.105469 133.546875 48.058594 132.929688 47.792969 131.902344 L 40.308594 102.878906 C 40.046875 101.851562 40.664062 100.804688 41.691406 100.539062 L 74.296875 92.128906 C 75.324219 91.867188 76.371094 92.484375 76.636719 93.511719 L 84.121094 122.535156 C 84.386719 123.5625 83.765625 124.609375 82.742188 124.875 Z M 82.742188 124.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 97.875 183.5625 L 65.269531 191.96875 C 64.242188 192.234375 63.195312 191.617188 62.929688 190.589844 L 55.445312 161.566406 C 55.179688 160.539062 55.796875 159.492188 56.824219 159.222656 L 89.429688 150.816406 C 90.457031 150.550781 91.503906 151.171875 91.769531 152.195312 L 99.253906 181.222656 C 99.519531 182.25 98.902344 183.296875 97.875 183.5625 Z M 97.875 183.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 113.007812 242.246094 L 80.402344 250.65625 C 79.375 250.921875 78.328125 250.300781 78.0625 249.277344 L 70.578125 220.25 C 70.3125 219.222656 70.929688 218.175781 71.957031 217.910156 L 104.566406 209.503906 C 105.59375 209.238281 106.640625 209.855469 106.90625 210.882812 L 114.390625 239.90625 C 114.652344 240.933594 114.035156 241.980469 113.007812 242.246094 Z M 113.007812 242.246094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 327.328125 54.996094 L 139.171875 54.996094 C 125.886719 55.011719 115.121094 65.773438 115.109375 79.058594 L 115.109375 299.996094 C 115.121094 313.28125 125.886719 324.042969 139.171875 324.058594 L 327.328125 324.058594 C 340.613281 324.042969 351.375 313.28125 351.390625 299.996094 L 351.390625 79.058594 C 351.375 65.773438 340.613281 55.011719 327.328125 54.996094 Z M 327.328125 54.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 327.328125 61.921875 L 139.171875 61.921875 C 129.710938 61.933594 122.046875 69.597656 122.035156 79.058594 L 122.035156 299.996094 C 122.046875 309.457031 129.710938 317.121094 139.171875 317.132812 L 327.328125 317.132812 C 336.789062 317.121094 344.453125 309.457031 344.464844 299.996094 L 344.464844 79.058594 C 344.453125 69.597656 336.789062 61.933594 327.328125 61.921875 Z M 327.328125 61.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.686275%,80.784314%,86.666667%)",
      fillOpacity: 1
    },
    d: "M 391.023438 307.015625 C 391.023438 331.273438 371.355469 350.941406 347.097656 350.941406 C 322.835938 350.941406 303.171875 331.273438 303.171875 307.015625 C 303.171875 282.753906 322.835938 263.089844 347.097656 263.089844 C 371.355469 263.089844 391.023438 282.753906 391.023438 307.015625 Z M 391.023438 307.015625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 368.105469 301.285156 L 352.828125 301.285156 L 352.828125 286.007812 C 352.828125 282.84375 350.261719 280.277344 347.097656 280.277344 C 343.933594 280.277344 341.367188 282.84375 341.367188 286.007812 L 341.367188 301.285156 L 326.089844 301.285156 C 322.925781 301.285156 320.359375 303.851562 320.359375 307.015625 C 320.359375 310.179688 322.925781 312.746094 326.089844 312.746094 L 341.367188 312.746094 L 341.367188 328.023438 C 341.367188 331.1875 343.933594 333.75 347.097656 333.75 C 350.261719 333.75 352.828125 331.1875 352.828125 328.023438 L 352.828125 312.746094 L 368.105469 312.746094 C 371.269531 312.746094 373.835938 310.179688 373.835938 307.015625 C 373.835938 303.851562 371.269531 301.285156 368.105469 301.285156 Z M 368.105469 301.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 299.011719 183.328125 L 203.859375 183.328125 C 202.429688 183.328125 201.101562 182.566406 200.386719 181.324219 C 199.667969 180.085938 199.667969 178.554688 200.386719 177.316406 C 201.101562 176.074219 202.429688 175.3125 203.859375 175.3125 L 299.011719 175.3125 C 301.222656 175.316406 303.015625 177.109375 303.015625 179.320312 C 303.015625 181.53125 301.222656 183.324219 299.011719 183.328125 Z M 299.011719 183.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 315.539062 196.851562 L 203.859375 196.851562 C 202.429688 196.851562 201.101562 196.089844 200.386719 194.847656 C 199.667969 193.609375 199.667969 192.082031 200.386719 190.839844 C 201.101562 189.597656 202.429688 188.835938 203.859375 188.835938 L 315.539062 188.835938 C 317.753906 188.835938 319.546875 190.632812 319.546875 192.84375 C 319.546875 195.058594 317.753906 196.851562 315.539062 196.851562 Z M 315.539062 196.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 299.011719 243.933594 L 203.859375 243.933594 C 202.429688 243.9375 201.101562 243.171875 200.386719 241.933594 C 199.667969 240.691406 199.667969 239.164062 200.386719 237.921875 C 201.101562 236.683594 202.429688 235.917969 203.859375 235.921875 L 299.011719 235.921875 C 301.222656 235.921875 303.019531 237.714844 303.019531 239.925781 C 303.019531 242.140625 301.222656 243.933594 299.011719 243.933594 Z M 299.011719 243.933594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 315.539062 257.457031 L 203.859375 257.457031 C 202.429688 257.460938 201.101562 256.695312 200.386719 255.457031 C 199.667969 254.214844 199.667969 252.6875 200.386719 251.445312 C 201.101562 250.207031 202.429688 249.441406 203.859375 249.445312 L 315.539062 249.445312 C 316.972656 249.441406 318.296875 250.207031 319.015625 251.445312 C 319.730469 252.6875 319.730469 254.214844 319.015625 255.457031 C 318.296875 256.695312 316.972656 257.460938 315.539062 257.457031 Z M 315.539062 257.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 182.546875 202.992188 L 148.875 202.992188 C 147.8125 202.988281 146.953125 202.128906 146.953125 201.070312 L 146.953125 171.097656 C 146.953125 170.035156 147.8125 169.175781 148.875 169.175781 L 182.546875 169.175781 C 183.605469 169.175781 184.464844 170.035156 184.46875 171.097656 L 184.46875 201.070312 C 184.464844 202.128906 183.605469 202.988281 182.546875 202.992188 Z M 182.546875 202.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 182.546875 263.597656 L 148.875 263.597656 C 147.8125 263.597656 146.953125 262.738281 146.953125 261.675781 L 146.953125 231.703125 C 146.953125 230.640625 147.8125 229.78125 148.875 229.78125 L 182.546875 229.78125 C 183.605469 229.78125 184.464844 230.640625 184.46875 231.703125 L 184.46875 261.675781 C 184.464844 262.738281 183.605469 263.597656 182.546875 263.597656 Z M 182.546875 263.597656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80%,80%,80%)",
      fillOpacity: 1
    },
    d: "M 299.117188 115.859375 L 228.964844 115.859375 C 226.753906 115.859375 224.960938 114.066406 224.960938 111.851562 C 224.960938 109.640625 226.753906 107.847656 228.964844 107.847656 L 299.117188 107.847656 C 301.328125 107.847656 303.125 109.640625 303.125 111.851562 C 303.125 114.066406 301.328125 115.859375 299.117188 115.859375 Z M 299.117188 115.859375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80%,80%,80%)",
      fillOpacity: 1
    },
    d: "M 315.644531 129.382812 L 228.964844 129.382812 C 226.753906 129.382812 224.960938 127.589844 224.960938 125.378906 C 224.960938 123.164062 226.753906 121.371094 228.964844 121.371094 L 315.644531 121.371094 C 317.859375 121.371094 319.652344 123.164062 319.652344 125.378906 C 319.652344 127.589844 317.859375 129.382812 315.644531 129.382812 Z M 315.644531 129.382812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.686275%,80.784314%,86.666667%)",
      fillOpacity: 1
    },
    d: "M 213.441406 145.773438 L 148.769531 145.773438 C 147.707031 145.773438 146.847656 144.914062 146.847656 143.851562 L 146.847656 93.378906 C 146.847656 92.316406 147.707031 91.457031 148.769531 91.457031 L 213.441406 91.457031 C 214.5 91.457031 215.359375 92.316406 215.363281 93.378906 L 215.363281 143.851562 C 215.359375 144.914062 214.5 145.773438 213.441406 145.773438 Z M 213.441406 145.773438 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawAddFilesReV09GDark2023171042);
export default __webpack_public_path__ + "static/media/undraw_add_files_re_v09g_dark_2023171042.38484cb595f064e08615da1d18cf05f2.svg";
export { ForwardRef as ReactComponent };